// Régua de cobrança da carteira da pessoa (D+4, D+10, D+17, D+24): usada pela Cobrança
// (#6502) e pelo Pós-venda (#6503). A conta está em src/lib/visaoGeral/cobranca.ts.
import React from 'react';
import { formatarValorKpi } from '../../src/lib/dashboard/kpisDepartamento';
import type { ReguaDaCarteira } from '../../src/lib/visaoGeral/cobranca';
import { PainelDetalhe, plural } from './componentes';

const LISTA = 8;
const reais = (v: number) => formatarValorKpi(v, 'reais');
const dataCurta = (iso: string | null | undefined) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : '—');

export const PainelReguaDaCarteira: React.FC<{ regua: ReguaDaCarteira | null; hoje: string; className?: string }> = ({ regua, hoje, className }) => {
  const lista = regua ? [...regua.hoje, ...regua.atrasadas] : [];
  return (
    <PainelDetalhe titulo="Régua da minha carteira" acao={{ rotulo: 'Lembretes', para: '/financeiro/lembretes-cobranca' }} className={className}>
      {!regua ? (
        <div className="h-24 rounded-lg bg-gray-100 dark:bg-gray-700 animate-pulse" />
      ) : lista.length === 0 ? (
        <p className="text-sm text-gray-500 dark:text-gray-400">Nada da régua para hoje nem atrasado na sua carteira.</p>
      ) : (
        <>
          <div className="grid grid-cols-4 gap-2 mb-3">
            {regua.porEtapa.map(e => (
              <div key={e.etapa} className="rounded-lg bg-gray-50 dark:bg-gray-700/40 px-2 py-1.5 text-center">
                <span className="block text-xs font-semibold text-gray-500 dark:text-gray-400">{e.etapa}</span>
                <span className={`block text-lg font-bold ${e.atrasadas ? 'text-red-600 dark:text-red-400' : 'text-gray-800 dark:text-gray-100'}`}>{e.hoje + e.atrasadas}</span>
                <span className="block text-[11px] text-gray-400">{e.hoje ? `${e.hoje} hoje` : e.atrasadas ? 'atrasadas' : '—'}</span>
              </div>
            ))}
          </div>
          <ul className="divide-y divide-gray-100 dark:divide-gray-700">
            {lista.slice(0, LISTA).map(a => (
              <li key={a.id} className="flex items-start gap-3 py-2.5">
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium text-gray-800 dark:text-gray-100 truncate">{a.cliente_nome || 'Sem nome'}</span>
                  <span className="block text-xs text-gray-400">{a.etapa} · boleto vencido em {dataCurta(a.data_referencia)}</span>
                </span>
                <span className={`shrink-0 text-right text-xs font-semibold ${a.dia === hoje ? 'text-amber-700 dark:text-amber-400' : 'text-red-600 dark:text-red-400'}`}>
                  {a.dia === hoje ? 'hoje' : `era ${dataCurta(a.dia)}`}
                  {Number(a.valor_total) > 0 && <span className="block font-normal text-gray-500 dark:text-gray-400">{reais(Number(a.valor_total))}</span>}
                </span>
              </li>
            ))}
          </ul>
          <p className="text-xs text-gray-400 mt-3">
            Hoje primeiro; depois as atrasadas, da mais recente para a mais antiga (dívida nova responde melhor ao contato).
            D+4 e D+10: contato; D+17: notificação extrajudicial; D+24: conferência e negativação.
            {lista.length > LISTA && ` Mais ${plural(lista.length - LISTA, 'ação', 'ações')} nos Lembretes de Cobrança.`}
          </p>
        </>
      )}
    </PainelDetalhe>
  );
};
